import type { FlightSearchPagedResultData } from "./types";

export const getOfferByIdFromSearchResult = (
  response: FlightSearchPagedResultData,
  offerId: string | null,
) => {
  const offers = response.pages.flatMap((page) => page.offers);
  const selectedOffer = offers.find((offer) => offer.index === offerId);
  return selectedOffer;
};
